import React, { useState, useRef, useEffect } from 'react';
import { authAPI } from './SellerApi';

export default function SellerAuth({ onAuthSuccess }) {
  const [mode, setMode] = useState('login');
  const [step, setStep] = useState('mobile');
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [timer, setTimer] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const otpRefs = useRef([]);

  const [form, setForm] = useState({
    firstName: '', lastName: '', email: '', mobile: '',
    gst: '', pan: '', businessName: '', businessCategory: 'Apparel',
    addressLine1: '', addressLine2: '', city: '', state: 'Tamil Nadu', pincode: '',
  });

  useEffect(() => {
    if (timer > 0) {
      const t = setTimeout(() => setTimer(timer - 1), 1000);
      return () => clearTimeout(t);
    }
  }, [timer]);

  const handleSendOtp = async (e) => {
    e.preventDefault();
    if (mobile.length !== 10) return setError('Invalid Contact Parameter Length');
    setLoading(true); setError('');
    try {
      await authAPI.sendOtp(mobile);
      setTimer(60); setStep('otp');
    } catch (err) {
      setError(err.message || 'Verification token transmission pipeline failed.');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    const finalOtp = otp.join('');
    if (finalOtp.length !== 6) return setError('Incomplete verification sequence code');
    setLoading(true); setError('');
    try {
      const res = await authAPI.verifyOtp(mobile, finalOtp);
      if (res.isRegistered) {
        onAuthSuccess(res.token, res.user);
      } else {
        if (mode === 'login') {
          setError('Mobile unlisted. Transitioning registry mode.');
          setMode('register');
        }
        setForm(f => ({ ...f, mobile }));
        setStep('details');
      }
    } catch (err) {
      setError('Invalid authorization token profile mismatch match error.');
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await authAPI.register(form);
      onAuthSuccess(res.token, res.user);
    } catch (err) {
      setError(err.message || 'Registration structural handshake failed.');
    } finally {
      setLoading(false);
    }
  };

  const handleOtpChange = (idx, val) => {
    if (isNaN(val)) return;
    const nextOtp = [...otp];
    nextOtp[idx] = val.slice(-1);
    setOtp(nextOtp);
    if (val && idx < 5) otpRefs.current[idx + 1]?.focus();
  };

  return (
    <div className="sa-wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'var(--s0)' }}>
      <div className="sa-card" style={{ width: '100%', maxWidth: step === 'business' || step === 'details' ? 600 : 400, background: 'var(--s1)', padding: '2rem', borderRadius: 'var(--r-lg)', border: '1px solid var(--border)' }}>
        <h2 style={{ textAlign: 'center', fontFamily: 'var(--ff-display)' }}>ATR <span style={{ color: 'var(--em-400)' }}>MART SELLER HUB</span></h2>
        <p style={{ textAlign: 'center', color: 'var(--t3)', fontSize: 13, marginBottom: '1.5rem' }}>
          {mode === 'login' ? 'Access your merchant storefront cluster node' : 'Launch a new marketplace node'}
        </p>
        
        {error && <div className="sp-alert danger" style={{ marginBottom: '1rem' }}>{error}</div>}

        {step === 'mobile' && (
          <form onSubmit={handleSendOtp} className="sp-form-grid">
            <div className="sp-input-group">
              <label className="sp-label">Registered Contact Link</label>
              <input type="text" maxLength={10} className="sp-input" placeholder="10-Digit Mobile Number" value={mobile} onChange={e => setMobile(e.target.value.replace(/\D/g, ''))} required />
            </div>
            <button type="submit" className="sp-btn-primary" disabled={loading}>{loading ? 'Verifying Link...' : 'Request Validation OTP'}</button>
          </form>
        )}

        {step === 'otp' && (
          <form onSubmit={handleVerifyOtp} className="sp-form-grid">
            <label className="sp-label" style={{ textAlign: 'center' }}>Enter Validation Token sent to {mobile}</label>
            <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center', margin: '1rem 0' }}>
              {otp.map((digit, i) => (
                <input key={i} ref={el => otpRefs.current[i] = el} type="text" className="sp-input" style={{ width: 45, textAlign: 'center', fontSize: '1.2rem' }} maxLength={1} value={digit} onChange={e => handleOtpChange(i, e.target.value)} onKeyDown={e => e.key === 'Backspace' && !otp[i] && i > 0 && otpRefs.current[i - 1]?.focus()} />
              ))}
            </div>
            <button type="submit" className="sp-btn-primary" disabled={loading}>Authorize Terminal Access</button>
          </form>
        )}

        {step === 'details' && (
          <form onSubmit={(e) => { e.preventDefault(); setStep('business'); }} className="sp-form-grid">
            <div className="sp-input-row">
              <div className="sp-input-group"><label className="sp-label">First Name</label><input type="text" className="sp-input" value={form.firstName} onChange={e => setForm({ ...form, firstName: e.target.value })} required /></div>
              <div className="sp-input-group"><label className="sp-label">Last Name</label><input type="text" className="sp-input" value={form.lastName} onChange={e => setForm({ ...form, lastName: e.target.value })} required /></div>
            </div>
            <div className="sp-input-group"><label className="sp-label">Email Access Route</label><input type="email" className="sp-input" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required /></div>
            <button type="submit" className="sp-btn-primary">Proceed to Operational Setup</button>
          </form>
        )}

        {step === 'business' && (
          <form onSubmit={handleRegister} className="sp-form-grid">
            <div className="sp-input-group"><label className="sp-label">Corporate Marketplace Entity Name</label><input type="text" className="sp-input" value={form.businessName} onChange={e => setForm({ ...form, businessName: e.target.value })} required /></div>
            <div className="sp-input-row">
              <div className="sp-input-group"><label className="sp-label">GSTIN ID</label><input type="text" className="sp-input" value={form.gst} onChange={e => setForm({ ...form, gst: e.target.value })} required /></div>
              <div className="sp-input-group"><label className="sp-label">PAN Number</label><input type="text" className="sp-input" value={form.pan} onChange={e => setForm({ ...form, pan: e.target.value })} required /></div>
            </div>
            <div className="sp-input-group"><label className="sp-label">Dispatch Line 1</label><input type="text" className="sp-input" value={form.addressLine1} onChange={e => setForm({ ...form, addressLine1: e.target.value })} required /></div>
            <div className="sp-input-row">
              <div className="sp-input-group"><label className="sp-label">City Node</label><input type="text" className="sp-input" value={form.city} onChange={e => setForm({ ...form, city: e.target.value })} required /></div>
              <div className="sp-input-group"><label className="sp-label">Pincode</label><input type="text" maxLength={6} className="sp-input" value={form.pincode} onChange={e => setForm({ ...form, pincode: e.target.value.replace(/\D/g, '') })} required /></div>
            </div>
            <button type="submit" className="sp-btn-primary" disabled={loading}>{loading ? 'Deploying Retail Terminal...' : 'Deploy Marketplace Node'}</button>
          </form>
        )}
      </div>
    </div>
  );
}